<div class="modal-header">
  <h4 class="modal-title">Edit Filters</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group clearfix">
    <button type="button" class="btn btn-primary float-right ml-2"
            (click)="handleSubmit()">
      Apply
    </button>
    <button type="button" class="btn btn-secondary float-right"
            (click)="handleClearAll()">
      Clear All
    </button>
  </div>

  <hr>

  <app-date-range-filter
    [label]="'Date'"
    [idPrefix]="'created_at'"
    [(min)]="filters.created_at_min"
    [(max)]="filters.created_at_max"
    [(range)]="filters.created_at_range"></app-date-range-filter>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="resetPaymentMethodIn();">
      Clear
    </button>

    <label>Payment Method</label>

    <div class="form-check" *ngFor="let paymentMethod of PaymentMethodOptions">
      <input class="form-check-input" type="checkbox"
             id="paymentMethod{{ paymentMethod }}" name="paymentMethod{{ paymentMethod }}"
             [checked]="paymentMethodIsSelected(paymentMethod)" (change)="togglePaymentMethod(paymentMethod)">
      <label class="form-check-label" for="paymentMethod{{ paymentMethod }}">
        {{ getPaymentTypeDisplay(paymentMethod) }}
      </label>
    </div>

    <button class="btn btn-link btn-sm p-0"
            *ngIf="!allPaymentMethodsAreSelected()"
            (click)="resetPaymentMethodIn()">
      Select All
    </button>
    <button class="btn btn-link btn-sm p-0"
            *ngIf="allPaymentMethodsAreSelected()"
            (click)="filters.payment_method_in = ''">
      Deselect All
    </button>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.amount_min = undefined;filters.amount_max = undefined;">
      Clear
    </button>

    <label>Amount</label>

    <div class="row">
      <div class="col-6 pl-0">
        <label for="amount_min">At Least</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
          </div>
          <input class="form-control" id="amount_min" name="amount_min"
                 type="number" min="0" step="0.01"
                 [(ngModel)]="filters.amount_min">
        </div>
      </div>
      <div class="col-6 pl-0">
        <label for="amount_max">At Most</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
          </div>
          <input class="form-control" id="amount_max" name="amount_max"
                 type="number" min="0" step="0.01"
                 [(ngModel)]="filters.amount_max">
        </div>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="resetStatusIn();">
      Clear
    </button>

    <label>Status</label>

    <div class="form-check" *ngFor="let status of StatusOptions">
      <input class="form-check-input" type="checkbox"
             id="status{{ status }}" name="status{{ status }}"
             [checked]="statusIsSelected(status)" (change)="toggleStatus(status)">
      <label class="form-check-label" for="status{{ status }}">
        {{ getPaymentStatusDisplay(status) }}
      </label>
    </div>

    <button class="btn btn-link btn-sm p-0"
            *ngIf="!allStatusesAreSelected()"
            (click)="resetStatusIn()">
      Select All
    </button>
    <button class="btn btn-link btn-sm p-0"
            *ngIf="allStatusesAreSelected()"
            (click)="filters.status_in = ''">
      Deselect All
    </button>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.discount_association_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="discount_association_id">Discount Association</label>

        <div *ngIf="filters.discount_association_id !== undefined" class="ml-2 mb-2 mt-1">
          {{ getSelectedAssociationName() }}
          -
          <span class="text-danger cursor-pointer" (click)="filters.discount_association_id = undefined;">Remove</span>
        </div>

        <input class="form-control" type="text"
               id="discount_association_id" name="discount_association_id"
               *ngIf="filters.discount_association_id === undefined"
               [(ngModel)]="discountAssociationSearchInput"
               [ngbTypeahead]="handleAssociationTypeahead"
               [inputFormatter]="associationTypeaheadFormatter"
               [resultFormatter]="associationTypeaheadFormatter"
               [editable]="false"
               (selectItem)="filters.discount_association_id = $event.item.id;discountAssociationSearchInput = '';$event.preventDefault();">

        <small class="form-text text-muted">
          Use this filter to find payments which used association-specific discounts.
        </small>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.location_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="location_id">Payment Location</label>

        <select class="custom-select"
                id="location_id" name="location_id"
                [(ngModel)]="filters.location_id">
          <option [ngValue]="undefined">All Locations</option>
          <option *ngFor="let loc of locationList"
                  [ngValue]="loc.id">
            {{ loc.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <label>Linked Customer</label>

    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             id="does_not_have_linked_customer" name="does_not_have_linked_customer"
             [(ngModel)]="filters.does_not_have_linked_customer">
      <label class="form-check-label" for="does_not_have_linked_customer">
        Show only payments without a linked customer
      </label>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="handleClearAll()">
    Clear All
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Apply
  </button>
</div>
